import { render, staticRenderFns } from "./BIMPlanet.vue?vue&type=template&id=52799cf9&scoped=true"
import script from "./BIMPlanet.vue?vue&type=script&lang=js"
export * from "./BIMPlanet.vue?vue&type=script&lang=js"
import style0 from "./BIMPlanet.vue?vue&type=style&index=0&id=52799cf9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52799cf9",
  null
  
)

export default component.exports